module.exports = __webpack_public_path__ + "static/media/search.b389a0ab.svg";